var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBCheckbox = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1_22878_39658",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 0V2H20V0V-2H4V0ZM24 4H22V20H24H26V4H24ZM20 24V22H4V24V26H20V24ZM0 20H2V4H0H-2V20H0ZM4 24V22C2.89543 22 2 21.1046 2 20H0H-2C-2 23.3137 0.686292 26 4 26V24ZM24 20H22C22 21.1046 21.1046 22 20 22V24V26C23.3137 26 26 23.3137 26 20H24ZM20 0V2C21.1046 2 22 2.89543 22 4H24H26C26 0.686291 23.3137 -2 20 -2V0ZM4 0V-2C0.686291 -2 -2 0.686292 -2 4H0H2C2 2.89543 2.89543 2 4 2V0Z",
  fill: "#DFDFDF",
  mask: "url(#path-1-inside-1_22878_39658)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBCheckbox);
export { ForwardRef as ReactComponent };